<section class="component-tab component-tab--press component-tab--press-events tab--press-events">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 tab-title__col" *ngIf="pressEventsData.peb_heading != ''">
				<h2 class="tab__title" [innerHtml]="pressEventsData.peb_heading"></h2>
			</div>
			<div class="col-12 col-sm-12" *ngIf="press_event_data != ''">
				<div class="masonry-section masonry-section-js pe-grid row">
					<div class="grid-sizer"></div>
					<div class="col-12 col-sm-6 col-md-3 masonry-item pe-grid-item" *ngFor="let peItems of press_event_data">
						<div class="news-grid__item">
							<figure class="news__image" *ngIf="peItems.image">
								<a class="news__link" href="event/{{ peItems.slug }}">
									<img alt="{{ peItems.title }}" class="img-responsive" src="{{ peItems.image }}" width="{{peItems.imageWidth}}" height="{{peItems.imageHeight}}" [ngStyle]="{'width.px': peItems.imageWidth}" loading="lazy" />
								</a>
							</figure>
							<div class="news__content">
								<a class="news__link" href="event/{{peItems.slug}}">
									<span class="news_date"><i class="icon-clock"></i> {{ peItems.dateInterval }}</span>
									<h4 [innerHtml]="peItems.title"></h4>
									<div class="schedule-detail__org">
										<span *ngFor="let cVal of peItems.convenors;last as isLast">{{ cVal.name }} <b>{{ isLast ? '' : '| ' }}</b></span>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>